/**
 * Copyright IBM Corp. 2022, 2026
 */

/**
 * Remove zero width, invisible, and format characters from a string
 * These characters can be injected from DatoCMS or other sources and
 * cause issues with Posthog event tracking and URL generation
 */
export function cleanZeroWidthChars(text: string): string {
	return text
		.replace(
			/[\u200B-\u200D\uFEFF\uFFFD\u00AD\u034F\u2028\u2029\u202A-\u202F\u2060-\u206F]/g,
			'',
		)
		.trim()
}
